module.exports = __webpack_public_path__ + "static/media/b05.0e037a13.png";